import { Navigate, Outlet } from 'react-router-dom';
import { useGetCecmasMutation } from '../slices/usersApiSlice';
import { useEffect, useState } from 'react';
import { Card, Spin } from 'antd';

const AdminRoute = () => {
    const [gcemas] = useGetCecmasMutation();
    const [isLoading, setIsLoading] = useState(true);
    const [admin, setAdmin] = useState(false);
  
    const getmas = async () => {
      const res = await gcemas().unwrap();
      setAdmin(res.user);
      setIsLoading(false);
    }
    useEffect(()=> {
      getmas();
    }, [])

  return (
    isLoading ? (
    <Card>
        Please Wait Navigating to Admin Panel <Spin/>
    </Card>
    ) : (
    <>
        {admin ? <Outlet /> : <Navigate to='/login' replace />}
    </>    
  ) 

  )
};

export default AdminRoute;
